import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import Typography from 'material-ui/Typography';

import styles from 'styles/components/NoData';

@withStyles(styles)
@observer
export default class NoData extends Component {

  static propTypes = {
    visible: PropTypes.bool.isRequired,
    text: PropTypes.string
  }

  static defaultProps = {
    visible: false,
    text: 'Нет данных'
  }

  render() {
    const { classes, visible, text } = this.props;

    return visible && (
      <Typography variant='title' align='center' className={ classes.title }>
        { text }
      </Typography>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/NoData.js